function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M256 205l184 184c16 16 41 16 57 0s16-41 0-57L288 123c-9-9-21-13-32-12-11-1-23 3-32 12L15 332c-16 16-16 41 0 57s41 16 57 0z"
})));